module.exports = __webpack_public_path__ + "img/02.02383f72.jpg";